import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { ThemeService } from './theme.service';
import { UiService } from './ui.service';

@Component({
  selector: 'app-root',
  templateUrl: './app-view.component.html',
  styleUrls: ['./app-view.component.css']
})

export class AppViewComponent implements OnInit {
  private isLoggedIn: boolean = false;

  constructor(
    private auth: AuthService,
    private theme: ThemeService,
    public ui: UiService
  ) {
    this.ui.init();
    this.theme.init();
    auth.onAuthChanged
    .subscribe(authState => {
      this.isLoggedIn = !!(authState && authState.access_token);
      // pick the studio or the classic UI for the client that just logged in
      this.ui.resolve(authState);
    });
  }

  ngOnInit() {
    this.auth.init();
  }
};
